import { render, staticRenderFns } from "./base-input.vue?vue&type=template&id=627d0875&scoped=true"
import script from "./base-input.vue?vue&type=script&lang=js"
export * from "./base-input.vue?vue&type=script&lang=js"
import style0 from "./base-input.vue?vue&type=style&index=0&id=627d0875&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627d0875",
  null
  
)

export default component.exports